
<template>
    <div>
        <formdialog 
            :form="form" 
            :shadow="true"
            v-if="startRegistration"
            :dialog="startRegistration" 
            v-on:submitForm="registerDeviceProfile($event)"
            v-on:rejectForm="$emit('abort')"
        ></formdialog>
    </div>
</template>
<script>  
    import { mapState } from 'vuex'
    import {FormPayload,Validator,FormStructField} from '@/components/models/FormDialog'
    
    export default {
        name: "RegisterDeviceProfile",

        props:{
            values:Object
        },

        data: function(){
            return {
                startRegistration : false,
            }
        },
        
        computed: {
            ...mapState(
                {
                    deviceProfileModel: state => state.metadata.models.data.newDeviceProfile
                }
            ),

            model: function(){ 
                return this.deviceProfileModel
            }
        },

        mounted: function(){
            this.startRegistration = true
            this.buildForm()
            
        },

        methods: {
            registerDeviceProfile(deviceProfileModel){
                this.startRegistration=false

                this.$store.dispatch('deviceProfiles/createDeviceProfile',deviceProfileModel)
                .then(()=>{
                    this.$emit("completed")
                })
                .catch((err)=>{
                    this.$emit("abort",true)
                    throw err
                })
            },

            buildForm(){

                this.form = new FormPayload({
                    title: this.model.title,
                    icon: this.model.icon,
                    block: false,
                })

                for(let index in this.model.fields){
                    let fieldModel = this.model.fields[index]
                    let field =  new FormStructField({
                        name: fieldModel.name,
                        label: fieldModel.label,
                        type: fieldModel.type,
                        icon: fieldModel.icon,
                        show: fieldModel.show,
                        select: (!fieldModel.values)?((this.values)?this.values[fieldModel.name]:fieldModel.values):fieldModel.values,
                        default: fieldModel.default,
                        hint : fieldModel.hint,
                        disableIfDefined: fieldModel.disableIfDefined,
                        if:fieldModel.if,
                        randgen: fieldModel.randgen
                    })
                    let validator = new Validator({
                        regex: fieldModel.regexp,
                        required: fieldModel.required,
                        min: fieldModel.min,
                        max: fieldModel.max
                    })
                    field.setValidator(validator)
                    this.form.addField(field)
                }
            }
        }
    }
</script>